/**
 * MypageCouponContainer
 * --
 */
import React from 'react';
import MypageCouponPresenter from './MypageCouponPresenter';
import { useUserDataAction, useUserDataStack, useUserStack } from 'store';
import Formatter from 'utils/Formatter';
import MessageAlert from 'utils';
import { useRegisterCouponUser } from 'hooks/CouponUserHooks';

const TAP = [
  {
    label: '사용가능',
    value: 'ACTIVE',
  },
  {
    label: '사용완료 & 기간만료',
    value: 'INACTIVE',
  },
];

const MypageCouponContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;
  /* ===== Mutate ===== */
  const { registerCouponUser } = useRegisterCouponUser();

  /* ===== Store ===== */
  const userInfo = useUserStack();
  const { couponList } = useUserDataStack();
  const userDataAction = useUserDataAction();

  /* ===== STATE ===== */
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);
  // 탭
  const [activeTab, setActiveTab] = React.useState('ACTIVE'); // 'active' or 'inactive'
  // 입력값
  const [inputValue, setInputValue] = React.useState('');

  /* ===== VARIABLE ===== */
  const today = Formatter.dateToUnix();

  /* ===== FUNCTION ===== */
  /**
   * ANCHOR 쿠폰 등록
   * --
   */
  const handleRegister = async () => {
    if (!inputValue) {
      MessageAlert.info('쿠폰 번호를 입력해주세요!');
      return;
    }

    try {
      setIsLoading(true);

      const res = await registerCouponUser({
        user_id: userInfo.user_id,
        coupon_code: inputValue,
      });

      if (res.status !== 200) {
        console.log(res);
        MessageAlert.info('발급받을 수 없는 쿠폰입니다!');
        return;
      }

      userDataAction.addData('couponList', res.data);
      MessageAlert.success('쿠폰이 발급되었습니다.');
    } catch (err) {
      console.error(`[handleRegister] Error!! ${err}`);
      MessageAlert.error('쿠폰 등록에 실패하였습니다!');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /* ===== HOOKS ===== */
  /**
   * 쿠폰 목록 정제
   * --
   */
  const CouponList = React.useMemo(() => {
    const newCouponList = couponList.map((coupon) => ({
      title: coupon.policy_coupon.coupon_name,
      content: coupon.policy_coupon.coupon_content.standard ?? '-',
      expiry_date: Formatter.unixToDate(coupon.expired_date, 'YYYY-MM-DD'),
      status:
        coupon.expired_date >= today && !coupon.useDate ? 'ACTIVE' : 'INACTIVE',
    }));

    const divCouponList = newCouponList.reduce(
      (acc, coupon) => {
        acc[coupon.status].push(coupon);

        return acc;
      },
      { ACTIVE: [], INACTIVE: [] }
    );

    return divCouponList;
  }, [couponList, today]);

  /* ===== RENDER ===== */
  return (
    <>
      <MypageCouponPresenter
        coupons={CouponList}
        tabItem={TAP}
        activeTab={activeTab}
        isLoading={isLoading}
        inputValue={inputValue}
        onTabChange={setActiveTab}
        onRegister={handleRegister}
        onChange={setInputValue}
        screenSize={screenSize}
      />
    </>
  );
};

export default MypageCouponContainer;
